// Shared by both forks; the old one restyles it with `styled()` (SpotlightOLD.tsx).
import React from 'react';
import styled from 'styled-components';
import { useTranslate } from '@bynder/localization';
import { Chip, token } from '@bynder/design-system';
import { IconTextField, IconTitle } from '@bynder/icons';
import { SearchOptionType } from '../helpers/types';
import { SEARCH_OPTION_DEFINITIONS } from '../SearchOptions/constants';
import { useSearchScope } from '../SpotlightState';

interface Props {
	className?: string;
}

export function SelectedSearchOptions({ className }: Props) {
	const { selectedSearchOptions, removeSelectedSearchOption } = useSearchScope();
	const { translate } = useTranslate();

	return (
		<StyledContainer data-testid="spotlightSelectedSearchOptions" className={className}>
			{selectedSearchOptions.map(({ key }) => {
				const searchOption = SEARCH_OPTION_DEFINITIONS[key];

				if (!searchOption) {
					return null;
				}

				const chipIcon =
					searchOption.key === SearchOptionType.Title ? <IconTitle /> : <IconTextField />;

				return (
					<Chip
						size="s"
						onDelete={() => removeSelectedSearchOption(key)}
						icon={chipIcon}
						key={key}
					>
						{translate(searchOption.translationKey)}
					</Chip>
				);
			})}
		</StyledContainer>
	);
}

const StyledContainer = styled.div`
	display: flex;
	flex-shrink: 0;
	gap: ${token.spacing2};
	align-items: center;
`;
